import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type APIConfig } from "../../types/api";
import { type Workspace } from "../../types/workspace";
import { type PayloadActionForAPI } from "../../types/app";

export type WorkspacesSliceState = {
   list?: Workspace[];
   archived?: Workspace[];
};

const initialState: WorkspacesSliceState = {};

export const workspacesSlice = createSlice({
   name: "workspaces",
   initialState,
   reducers: {
      getAllWorkspaces: (_, __: PayloadActionForAPI<APIConfig["getAllWorkspaces"], {}, true>) => {},
      getWorkspaceById: (
         _,
         __: PayloadActionForAPI<
            APIConfig["getWorkspaceById"],
            {
               id: Workspace["id"];
            }
         >,
      ) => {},
      setWorkspaces: (state, action: PayloadAction<WorkspacesSliceState["list"]>) => {
         state.list = action.payload;
      },
      setArchivedWorkspaces: (state, action: PayloadAction<WorkspacesSliceState["archived"]>) => {
         state.archived = action.payload;
      },
      createWorkspace: (_, __: PayloadActionForAPI<APIConfig["createWorkspace"]>) => {},
      editWorkspace: (
         _,
         __: PayloadActionForAPI<
            APIConfig["editWorkspace"],
            {
               id: Workspace["id"];
            }
         >,
      ) => {},
      workspaceOperations: (
         _,
         __: PayloadActionForAPI<
            APIConfig["workspaceOperations"],
            {
               id: Workspace["id"];
            }
         >,
      ) => {},
      updateWorkspace: (
         state,
         action: PayloadAction<
            NonNullable<WorkspacesSliceState["list"]> | NonNullable<WorkspacesSliceState["list"]>[number]
         >,
      ) => {
         const newItems = Array.isArray(action.payload) ? action.payload : [action.payload];

         if (!state.list) state.list = [];

         for (let index = 0; index < newItems.length; index++) {
            const newItem = newItems[index];
            const stateListIndex = state.list.findIndex((item) => item.id === newItem.id);

            if (stateListIndex !== -1)
               state.list[stateListIndex] = {
                  ...state.list[stateListIndex],
                  ...newItem,
               };
            else state.list.push(newItem);
         }
      },
      removeWorkspace: (state, action: PayloadAction<NonNullable<WorkspacesSliceState["list"]>[number]["id"]>) => {
         state.list = state.list?.filter((item) => item.id !== action.payload);
      },

      createWorkspaceShareLink: (
         _,
         __: PayloadActionForAPI<
            APIConfig["createWorkspaceShareLink"],
            {
               id: Workspace["id"];
            }
         >,
      ) => {},
   },
});
